var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.currentMessage)?_c('v-snackbar',{attrs:{"value":_vm.showSnackbar,"color":_vm.currentMessage.color,"right":"","bottom":""}},[_vm._v(" "+_vm._s(_vm.currentMessage.text)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }